import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const API_URL = `${API_HOST}/api/clientAppKey`;

function* searchClientAppKeys() {
  yield takeEvery(actions.SEARCH_CLIENT_APP_KEYS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_URL}?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_CLIENT_APP_KEYS_ENDED });
    }
  });
}

function* createClientAppKey() {
  yield takeEvery(actions.CREATE_CLIENT_APP_KEY, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.CREATE_CLIENT_APP_KEY_ENDED });
    }
  });
}

function* updateClientAppKey() {
  yield takeEvery(actions.UPDATE_CLIENT_APP_KEY, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_CLIENT_APP_KEY_ENDED });
    }
  });
}

function* updateClientAppKeyEnable() {
  yield takeEvery(actions.UPDATE_CLIENT_APP_KEY_ENABLE, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${API_URL}/enable`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_CLIENT_APP_KEY_ENABLE_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createClientAppKey),
    fork(searchClientAppKeys),
    fork(updateClientAppKey),
    fork(updateClientAppKeyEnable),
  ]);
}
